module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/names_and_relationships"
    }
  }, [_vm._v("NAMES AND RELATIONSHIPS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue"
    }
  }, [_vm._v("PROLOGUE: Welcome to Khar Yalla")])]), _vm._v(" "), _c('p', {
    staticClass: "nospace"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter_001"
    }
  }, [_vm._v("1. Global Senegal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Homes and Their Histories")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Promise of Paradise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. A Tale of Two Sisters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Lamb Slaughtered")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Home Economics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter_007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Only Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0